import { gql } from "@apollo/client";

export const QUERY_SEASONS = gql`
  query getSeasons {
    getSeasons {
      globalUniqueId
      seasonNumber
    }
  }
`;

export const QUERY_EVENTS_FOR_SEASON = gql`
  query getEventsForSeason($season: Int!) {
    getEventsForSeason(season: $season) {
      eventCode
      globalUniqueId
      isOfficialFiaEvent
    }
  }
`;

export const QUERY_SESSIONS_FOR_EVENT = gql`
  query getSessionsForEvent($eventCode: String!) {
    getSessionsForEvent(eventCode: $eventCode) {
      globalUniqueId
      displayName
    }
  }
`;
